(() => {
  const BLOCK_SELECTOR = '.product-info__block-item[data-block-type="image"], .product-info__block-item[data-block-type="@app"]';

  function relocate(root = document) {
    const host = root.querySelector('[data-product-details-drawer-extras]');
    if (!host) return;

    const productInfo = host.closest('product-rerender, .product, [id^="product-info-"]') || root;
    const sources = productInfo.querySelectorAll(BLOCK_SELECTOR);
    if (!sources.length) return;

    sources.forEach((node) => {
      if (host.contains(node)) return;
      host.appendChild(node);
    });
  }

  function init() {
    relocate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    relocate(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    relocate();
  });
})();
